export default __webpack_public_path__ + "locales/nl/ChangePhoneDialog.json?hash=7bbb9082fac62551b8dd2e95067ed79f";